var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "owa-modal-frame",
    {
      staticStyle: {
        "--card-roomy-horizontal-padding": "var(--spacing-xl)",
        "--modal-margin-top": "var(--spacing-6xl)",
      },
      attrs: {
        "component-class": "build-awesome",
        "is-showing": _vm.isShowing,
      },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "header",
          staticStyle: {
            margin:
              "calc(var(--card-roomy-vertical-padding) * -1) calc(var(--card-roomy-horizontal-padding) * -1) var(--card-roomy-vertical-padding)",
            "border-radius":
              "var(--card-border-radius) var(--card-border-radius) 0 0",
            overflow: "hidden",
            position: "relative",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: "/images/build-awesome-placeholder.png",
                  alt: "Build Awesome by Font Awesome",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "ba-kickstarter-video",
              staticStyle: { padding: "56.25% 0 0 0", position: "relative" },
            },
            [
              _vm.isShowing
                ? _c("iframe", {
                    staticStyle: {
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                    },
                    attrs: {
                      src: "https://player.vimeo.com/video/1168551192?h=6ba669b3ff&badge=0&autopause=0&player_id=0&app_id=58479",
                      frameborder: "0",
                      allow:
                        "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share",
                      referrerpolicy: "strict-origin-when-cross-origin",
                      title:
                        "Now on Kickstarter: Build Awesome - Collaborate on Web Sites That Last",
                    },
                  })
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "h3 margin-bottom-md" }, [
        _c("strong", [
          _vm._v("Introducing "),
          _c(
            "span",
            { staticStyle: { color: "var(--brand-build-awesome-green)" } },
            [_vm._v("Build Awesome!")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "margin-bottom-md" }, [
        _vm._v(
          "\n    Build Awesome is a new way to build fast, beautiful websites. Open-source at its core, but now with endless Pro 'possum-bilities. (And it works perfectly with Font Awesome!) \n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "button block margin-bottom-xs margin-top-xl",
          staticStyle: { "--button-hover-background": "#ade1c6" },
          attrs: {
            href: "https://www.kickstarter.com/projects/fontawesome/build-awesome?ref=91katr",
            target: "_blank",
          },
        },
        [
          _c("span", [_vm._v("Check Out the Build Awesome Kickstarter!")]),
          _vm._v(" "),
          _c("font-awesome-icon", {
            staticClass: "margin-left-3xs",
            attrs: { icon: _vm.$v6.solid.faArrowUpRightFromSquare, size: "lg" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }